/**
 * WHAT: Cassandra-specific wrapper for the generic PasswordPolicyCompliance component.
 * WHY: Each database technology has its own route/menu entry for password compliance;
 *      this thin wrapper passes technology="cassandra" so the generic component
 *      fetches Cassandra-specific password policy rules and compliance data.
 */

import React from 'react';
import PasswordPolicyCompliance from './PasswordPolicyCompliance';

/**
 * WHAT: Renders PasswordPolicyCompliance pre-configured for Cassandra.
 * WHY: Provides a dedicated entry point for the Cassandra password compliance route.
 */
const CassandraPasswordCompliance = () => {
  return <PasswordPolicyCompliance technology="cassandra" />;
};

export default CassandraPasswordCompliance;
